import React from 'react'
import { Button } from './Button';
import { Spotify } from 'react-spotify-embed';
import './HeroSection.css';

function HeroSection() {
    return (
        <div className='hero-container'>
          <div className='social-icons'>
          <a
              className='social-icon-link spotify'
              href='https://open.spotify.com/artist/46GltPuUxikh6VuxhJSB1Z'
              target='_blank'
              rel='noreferrer'
              aria-label='Spotify'
            >
              <i className='fab fa-spotify' />
            </a>   
            <a
              className='social-icon-link applemusic'
              href='https://music.apple.com/us/artist/boom-chr-paige/80850403'
              target='_blank'
              rel='noreferrer'
              aria-label='Apple Music'
            >
              <i className='fab fa-apple' />
            </a>  
            <a
              className='social-icon-link instagram'
              href='https://www.instagram.com/boomchrpaige/'
              target='_blank'
              rel='noreferrer'
              aria-label='Instagram'
            >
              <i className='fab fa-instagram' />
            </a>
            <a
              className='social-icon-link youtube'
              href='https://www.youtube.com/c/SeriousBoom'
              target='_blank'
              rel='noreferrer'
              aria-label='Youtube'
            >
              <i className='fab fa-youtube' />
            </a>
            <a
              className='social-icon-link soundcloud'
              href='https://soundcloud.com/boomchrpaige'
              target='_blank'
              rel='noreferrer'
              aria-label='SoundCloud'
            >
              <i className='fab fa-soundcloud' />
            </a>
            <a
              className='social-icon-link bandcamp'
              href='https://boomchrpaige.bandcamp.com'
              target='_blank'
              rel='noreferrer'
              aria-label='Bandcamp'
            >
              <i className='fab fa-bandcamp' />
            </a>      


          </div>
            <h1>Under the Influence</h1>
            <p>The latest techno blast, harkening on the influences over the decades</p>
            <Spotify link="https://open.spotify.com/album/6PII5s32Gwwro9L5BHOndZ" width='60%' height='352' />
            <h1>Open Conversation</h1>
            <p>Five techno bangers, wrapped in beautiful artwork from Duck Bacon Graphics</p>
            <Spotify link="https://open.spotify.com/album/2WxPRYJuDwf1PKIkDmreHS" width='60%' height='352' />
            <h1>Black Sky (Revisited)</h1>
            <Spotify link="https://open.spotify.com/album/1JImuY3jZaLKbTkRpLzD0W" width='60%' height='352' />
            <h1>Manufactured Safety</h1>
            <p>Six tracks, including 3 new remixes from Twitch, Sigint & Boom. 2 new unreleased tracks.</p>
            <Spotify link="https://open.spotify.com/album/3FHjxDu7wr9OQxw4XBI8qq" width='60%' height='352' />
            <h1>xoxo</h1>
            <Spotify link="https://open.spotify.com/album/07sq8M3RsaKy6G6Hjys5IR" width='60%' height='352' />
            <h1>Ring Ring EP</h1>
            <p>Seven tracks, including 5 new remixes from Twitch, Sigint & Boom. 2 new unreleased tracks.</p>
            <Spotify link="https://open.spotify.com/album/4MxJhRMEb4R8rjoGcYfAs4" width='60%' height='352' />
            <h4>HUAC-A-Mole LP</h4>
            <p>Full length album with a balance of techno, industrial, synthwave and electro.</p>
            <Spotify link="https://open.spotify.com/album/62bk6xWqrQAV5luCX7KMOw" width='60%' height='352'/>
            <div className='hero-btns'>
            <Button 
                    className='btns' 
                    buttonStyle='btn--primary' 
                    buttonSize='btn-large'
                    onClick={(e) => {
                        e.preventDefault();
                        window.location.href='https://open.spotify.com/album/4MxJhRMEb4R8rjoGcYfAs4';
                        }}
                    >
                        STREAM ON SPOTIFY <i className='far fa-play-circle' />
            </Button>
            <Button 
                    className='btns' 
                    buttonStyle='btn--primary' 
                    buttonSize='btn-large'
                    onClick={(e) => {
                        e.preventDefault();
                        window.location.href='https://boomchrpaige.bandcamp.com/album/ring-ring-single';
                        }}
                    >
                        PURCHASE ON BANDCAMP <i className='far fa-play-circle' />
            </Button>
            <Button 
                    className='btns' 
                    buttonStyle='btn--primary' 
                    buttonSize='btn-large'
                    onClick={(e) => {
                        e.preventDefault();
                        window.location.href='https://music.amazon.com/albums/B0BQ432GQG?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_qoUmsxlarJWCcw6X8VxYuNxCp';
                        }}
                    >
                        LISTEN AT AMAZON <i className='far fa-play-circle' />
            </Button>
            <Button
                    className='btns' 
                    buttonStyle='btn--outline' 
                    buttonSize='btn-large'
                    onClick={(e) => {
                        e.preventDefault();
                        window.location.href='https://music.apple.com/us/artist/boom-chr-paige/80850403';
                        }}
                    >
                        LISTEN ON APPLE MUSIC <i className='far fa-play-circle' />
            </Button>
            </div>
        </div>
    )
}

export default HeroSection;
